const de = {
  home: {
    biometric_label: "BIOMETRISCHE IDENTITÄTSVERIFIZIERUNG",
    title: "Gesichtssuche leicht gemacht",
    description:
      "Laden Sie ein hochauflösendes Porträt hoch, um es mit globalen digitalen Archiven unter Verwendung fortschrittlicher neuronaler Abgleichmethoden zu vergleichen.",
    drag_drop: "Bild hierher ziehen und ablegen",
    file_formats: "Unterstützt RAW, JPEG oder PNG (Max 15MB)",
    select_file: "DATEI VOM SYSTEM AUSWÄHLEN",
    initiate_scan: "Forensischen Scan starten",
    upload_hint: "BITTE EIN BILD HOCHLADEN UM FORTZUFAHREN",
    uploading: "Hochladen",
    searching: "Scannen",
    result_title: "Ergebnisse",
    drop_here: "Bild hier ablegen...",
    billion_faces: "Vergleiche mit über 1 Milliarde Gesichtern im Internet",
    login_to_search: "Anmelden zum Suchen",
    login_required:
      "Melden Sie sich an oder erstellen Sie ein Konto, um diese App zu nutzen",
    not_enough_tokens: "Nicht genug Token",
    please_wait: "Bitte warten Sie einige Minuten",
    leave_confirmation:
      "Ein Prozess läuft gerade. Bist du sicher, dass du die Seite verlassen möchtest?",
  },
  sources: {
    section_title: "Durchsuchte Quellen",
    social_media: {
      name: "Soziale Medien",
      description:
        "Kreuzreferenzen in großen sozialen Netzwerken und öffentlichen Profilen.",
    },
    web: {
      name: "Web",
      description:
        "Durchsucht das offene Web nach öffentlich verfügbaren Gesichtsdaten.",
    },
    scammers: {
      name: "Betrüger",
      description:
        "Abgleich mit bekannten Betrüger-Identitäts- und Betrugs-Datenbanken.",
    },
    sexual_offenders: {
      name: "Sexualstraftäter",
      description: "Kreuzreferenzen mit öffentlichen Straftäterregistern.",
    },
    videos: {
      name: "Videos",
      description:
        "Extrahiert und vergleicht Gesichter von öffentlichen Videoplattformen.",
    },
    police_photos: {
      name: "Polizeifotos",
      description: "Vergleich mit öffentlich zugänglichen Polizeidatenbanken.",
    },
    news_and_blogs: {
      name: "Nachrichten & Blogs",
      description:
        "Sucht in Nachrichtenarchiven, redaktionellen Inhalten und Blogs.",
    },
  },
  header: {
    scan: "SCAN",
    history: "VERLAUF",
    pricing: "PREISE",
    account: "KONTO",
    logout: "ABMELDEN",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. Alle Rechte vorbehalten. Präzise Identitätsverifizierung.",
    privacy: "Datenschutzrichtlinie",
    terms: "Nutzungsbedingungen",
    docs: "Dokumentation",
    support: "Support",
  },
  common: {
    loading: "Laden...",
    error: "Fehler",
    cancel: "Abbrechen",
    back: "Zurück",
  },
  errors: {
    upload_failed: "Upload fehlgeschlagen. Bitte versuchen Sie es erneut.",
    not_enough_tokens:
      "Sie haben nicht genug Token, um diese Suche durchzuführen.",
  },
  login: {
    disclaimer:
      "Du benötigst ein Konto, um diese App zu nutzen. Wir senden keinen Spam und teilen deine E-Mail nicht. Wir empfehlen, dich mit Apple anzumelden, um deine Privatsphäre zu schützen.",
  },
  results: {
    input_source: "EINGABEQUELLE",
    match_thumbnail: "Vorschaubild des Treffers",
    extraction_id: "EXTRAKTIONS-ID",
    scan_analysis: "Scan-Analyse",
    scan_description:
      "Biometrische Rückwärtssuche abgeschlossen. %{count} potenzielle Übereinstimmungen in öffentlichen Registern und sozialen Indizes gefunden.",
    col_identity_map: "IDENTITÄTSKARTE",
    col_verification_path: "VERIFIZIERUNGSPFAD",
    col_bio_match_score: "BIO-MATCH-WERT",
    col_action: "AKTION",
    export_pdf: "PDF exportieren",
    exporting: "Erstelle...",
    verified: "VERIFIZIERT",
    details: "DETAILS",
    details_tooltip: "Präzisen Gesichtsvergleich ausführen",
    details_loading: "Vergleiche...",
    copied: "Kopiert!",
    copy_url: "URL kopieren",
    displaying: "Zeige %{count} von %{total} Erkennungen",
  },
};

export default de;
